<template>
  <div class='app-container'>
    <el-input-number v-model="start"  :controls="false" :precision="searchType.precision" :step="searchType.step"
      :min="searchType.minVal" :max="searchType.maxVal" controls-position="right" />
    <el-input-number v-model="end"  :controls="false" :precision="searchType.precision" :step="searchType.step"
      :min="searchType.minVal" :max="searchType.maxVal" controls-position="right" />
  </div>
</template>

<script setup>
import { ref,watch,onMounted } from 'vue';


const props = defineProps({
  modelValue: {
    required: true
  },
  searchType: {
    required: true,
    type: Object
  },

})

const emits = defineEmits(['update:modelValue'])

const start = ref(props.modelValue[0])
const end = ref(props.modelValue[0])

onMounted(() => {
  watch([start, end], ([newStart, newEnd]) => {
    emits("update:modelValue",[newStart,newEnd])
  })
})


</script>

<style lang="scss" scoped>
</style>